import { QueryClient } from '@tanstack/react-query';

const sharedRpcStaleTimeMs = 30 * 1000;
const sharedRpcGcTimeMs = 10 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: sharedRpcStaleTimeMs,
      gcTime: sharedRpcGcTimeMs,
      refetchOnWindowFocus: false,
    },
  },
});
